import { composeIO } from 'react-compose-io'
import { customBreadcrumbsIO } from './CustomBreadcrumbs.IO'
import { CustomBreadcrumbsView } from './CustomBreadcrumbs.View'
import { withRouter } from 'react-router-dom'

export const CustomBreadcrumbs = withRouter(composeIO(CustomBreadcrumbsView, customBreadcrumbsIO))
